// extracted by mini-css-extract-plugin
export var activeIndex = "PortfolioProject-module--activeIndex--4c1dd";
export var back = "PortfolioProject-module--back--22899";
export var cMarginTop = "PortfolioProject-module--c-margin-top--5e158";
export var cPadding = "PortfolioProject-module--c-padding--fd559";
export var cPaddingBottom = "PortfolioProject-module--c-padding-bottom--ae038";
export var cPaddingTop = "PortfolioProject-module--c-padding-top--5391b";
export var cardStack = "PortfolioProject-module--cardStack--c6b2e";
export var content = "PortfolioProject-module--content--06af4";
export var contentTop = "PortfolioProject-module--contentTop--efcf3";
export var date = "PortfolioProject-module--date--807a3";
export var description = "PortfolioProject-module--description--40e0c";
export var disabled = "PortfolioProject-module--disabled--3b20e";
export var ellipsis = "PortfolioProject-module--ellipsis--2d23a";
export var featuredSection = "PortfolioProject-module--featuredSection--bc068";
export var firstItem = "PortfolioProject-module--firstItem--171df";
export var flexContainer = "PortfolioProject-module--flexContainer--1bf62";
export var globalSpacing = "PortfolioProject-module--global-spacing--9cb34";
export var globalSpacingBottom = "PortfolioProject-module--global-spacing-bottom--aab6f";
export var globalSpacingTop = "PortfolioProject-module--global-spacing-top--35d24";
export var image = "PortfolioProject-module--image--50bd2";
export var imageWrapper = "PortfolioProject-module--imageWrapper--99f5f";
export var index = "PortfolioProject-module--index--12fcd";
export var listItem = "PortfolioProject-module--listItem--b657f";
export var logo = "PortfolioProject-module--logo--074a9";
export var maxWidth = "PortfolioProject-module--max-width--cf337";
export var middle = "PortfolioProject-module--middle--8cc12";
export var navButton = "PortfolioProject-module--navButton--89a3c";
export var pagination = "PortfolioProject-module--pagination--2ff8f";
export var para = "PortfolioProject-module--para--a4505";
export var projectCard = "PortfolioProject-module--projectCard--98b1a";
export var projectScrollContainer = "PortfolioProject-module--projectScrollContainer--9b276";
export var readmore = "PortfolioProject-module--readmore--5f7e4";
export var stackWrapper = "PortfolioProject-module--stackWrapper--9e95f";
export var styleTick = "PortfolioProject-module--styleTick--37120";
export var tag = "PortfolioProject-module--tag--c5931";
export var tagWrapper = "PortfolioProject-module--tagWrapper--71a46";
export var tags = "PortfolioProject-module--tags--60b4c";
export var title = "PortfolioProject-module--title--d5098";
export var wrapper = "PortfolioProject-module--wrapper--99ef2";